import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Footer.st.css';
import { dataHooks } from '../../constants';
import Divider from '../../../Divider';
import { FooterProps } from './Footer.types';

class Footer extends PureComponent<FooterProps> {
  static displayName = 'Footer';

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    showDivider: PropTypes.bool,
    noPadding: PropTypes.bool,
  };

  static defaultProps = {
    showDivider: true,
    noPadding: false,
  };

  render() {
    const { children, className, showDivider, noPadding } = this.props;
    return (
      <div
        className={st(classes.root, {}, className)}
        data-hook={dataHooks.sidePanelFooter}
      >
        {showDivider && (
          <Divider
            className={classes.divider}
            dataHook={dataHooks.sidePanelHeaderDivider}
          />
        )}
        <div
          className={st(classes.footerContainer, {
            noPadding,
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Footer;
